export class RecModel {
    trdYmd?: string;
    trdCnt?: number;
    trdVol?: number;
    avgPrc?: number;

    constructor(data?: Partial<RecModel>) {
        Object.assign(this, data);
    }

    toMap(): Record<string, any> {
        return {
            trdYmd: this.trdYmd,
            trdCnt: this.trdCnt,
            trdVol: this.trdVol,
            avgPrc: this.avgPrc,
        };
    }

    static fromMap(data: Record<string, any>): RecModel {
        return new RecModel(data);
    }
}


